var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-spacer'),_c('v-col',[_c('v-select',{attrs:{"items":_vm.displayModes,"hide-details":""},model:{value:(_vm.displayModeModel),callback:function ($$v) {_vm.displayModeModel=$$v},expression:"displayModeModel"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }